/** Strips "EVK Vault " prefix, eLend-style leading "e", and trailing "-N" to get the asset symbol (e.g. "EVK Vault eWHYPE-2" -> "WHYPE"). */
export function cleanVaultName(name: string | null): string {
  if (!name) return 'Unknown'
  return name
    .replace(/^EVK Vault\s*/, '')
    .replace(/^e(?=[A-Z])/, '')
    .replace(/-\d+$/, '')
}
